import React, { Component } from "react";
import classes from "./Quiz.module.css";
import ActiveQuize from "../../components/ActiveQuiz/ActiveQuiz";
import FinishedQuiz from "../../components/FinishedQuiz/FinishedQuiz";
import Loader from "../../components/UI/Loader/Loader";
import {connect} from 'react-redux'
import { fetchQuizeById, quizAnswerClick, retryQuiz} from "../../store/actions/quiz";
class Quiz extends Component {
  async componentDidMount() {
    this.props.fetchQuizeById(this.props.match.params.id)
  }
  componentWillUnmount(){
    this.props.retryQuiz()
  }
  render() {
    return (
      <div className={classes.Quiz}>
        <div className={classes.QuizWrapper}>
          <h1>Ответьте на все вопросы</h1>
          {this.props.loading || !this.props.quiz ? (
            <Loader />
          ) : this.props.isFinished ? (
            <FinishedQuiz
              onRetry={this.props.retryQuiz}
              quiz={this.props.quiz}
              results={this.props.results}
            />
          ) : (
            <ActiveQuize
              onAnswerClick={this.props.quizAnswerClick}
              question={this.props.quiz[this.props.activeQuestion].question}
              answers={this.props.quiz[this.props.activeQuestion].answers}
              quizLength={this.props.quiz.length}
              answerNumber={this.props.activeQuestion + 1}
              answerState={this.props.answerState}
            />
          )}
        </div>
      </div>
    );
  }
}


const mapStateToProps = state => {
  return {
    results: state.quiz.results, 
    isFinished: state.quiz.isFinished, 
    activeQuestion:state.quiz.activeQuestion, 
    answerState: state.quiz.answerState, 
    quiz: state.quiz.quiz, 
    loading : state.quiz.loading 
  }
}

export default connect(mapStateToProps, {fetchQuizeById, quizAnswerClick, retryQuiz})(Quiz);
